/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} QueuedInputs */

const en_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queued`)
};

const fr_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En file d’attente`)
};

const de_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Warteschlange`)
};

const it_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In coda`)
};

const ru_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В очереди`)
};

const es_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cola`)
};

const zh_cn2_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已排队`)
};

const ja_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キューに登録`)
};

const hi_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कतारबद्ध`)
};

const pt_pt2_queued = /** @type {(inputs: QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em fila`)
};

/**
* | output |
* | --- |
* | "Queued" |
*
* @param {QueuedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const queued = /** @type {((inputs?: QueuedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<QueuedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_queued(inputs)
	if (locale === "de") return de_queued(inputs)
	if (locale === "it") return it_queued(inputs)
	if (locale === "ru") return ru_queued(inputs)
	if (locale === "es") return es_queued(inputs)
	if (locale === "zh-CN") return zh_cn2_queued(inputs)
	if (locale === "ja") return ja_queued(inputs)
	if (locale === "hi") return hi_queued(inputs)
	if (locale === "pt-PT") return pt_pt2_queued(inputs)
	return en_queued(inputs)
});